module.exports = __webpack_public_path__ + "img/whatsapp.64955b28.png";